export function buildCommercePayload({planPrice, discountCode, seats, customizations, idempotencyKey}) {
    const resolvedSeats = seats ?? planPrice?.capacity ?? planPrice?.includedSeats ?? 1;
    return {
        planPriceDocumentId: planPrice?.documentId ?? planPrice?.id ?? planPrice,
        discountCode: String(discountCode || "").trim() || undefined,
        seats: Number(resolvedSeats),
        ...(Array.isArray(customizations) ? {customizations} : {}),
        ...(idempotencyKey ? {idempotencyKey} : {}),
    };
}
